__turbopack_context__.v({
  "body": "ForumActivityModal-module-scss-module__9aaUfW__body",
  "content": "ForumActivityModal-module-scss-module__9aaUfW__content",
  "modal": "ForumActivityModal-module-scss-module__9aaUfW__modal",
  "root": "ForumActivityModal-module-scss-module__9aaUfW__root",
  "scrollContainer": "ForumActivityModal-module-scss-module__9aaUfW__scrollContainer",
  "tab": "ForumActivityModal-module-scss-module__9aaUfW__tab",
  "tabs": "ForumActivityModal-module-scss-module__9aaUfW__tabs",
  "title": "ForumActivityModal-module-scss-module__9aaUfW__title",
});
